// extracted by mini-css-extract-plugin
export var structure__blockHeaderTitle = "style-module--structure__block-header-title--4f4fe";
export var structure__blockTotal = "style-module--structure__block-total--85b0c";